<section class="bg-primary-dark text-white">
    @if (signUpError) {
        <app-landing-page-register-form-error
            class="text-black-important"
            (retryClick)="handleRetryClick()"
        ></app-landing-page-register-form-error>
    } @else if (signUpSuccess) {
        <app-landing-page-register-form-success
            [title]="successTitle"
            [subTitle]="successSubtitle"
            [showNextSteps]="!_isDemoRequest"
        ></app-landing-page-register-form-success>
    } @else {
        <div app-landing-page-section-container>
            <app-button
                class="-mt-8 mb-6 lg:-mt-16 lg:mb-8"
                buttonType="stroked-inverted"
                (buttonClick)="handleBackClick()"
                icon="chevron-left"
                iconPosition="left"
            >
                <translate>Back</translate>
            </app-button>

            <div
                [ngClass]="[
                    'flex',
                    'flex-col-reverse space-y-12',
                    'md:items-center',
                    'xl:flex-row xl:space-y-0 xl:space-x-6',
                ]"
            >
                <form
                    [formGroup]="formGroup"
                    class="w-full xl:flex-1"
                    (submit)="handleSubmit(formDirective)"
                    #formDirective="ngForm"
                >
                    <h1
                        [ngClass]="[
                            'm-0',
                            'text-3xl',
                            'md:text-5xl',
                            'lg:text-left',
                            'xl:text-6xl',
                        ]"
                        [translate]="title"
                    ></h1>

                    <div
                        class="md:pt-4 pb-8 md:pb-10"
                        [translate]="subtitle"
                    ></div>

                    <div class="flex flex-col sm:flex-row gap-x-6 mb-[5px]">
                        <mat-form-field class="w-full" appearance="outline">
                            <input
                                formControlName="firstName"
                                matInput
                                required
                                data-qa="landing-page_register-first-name"
                                aria-label="First name"
                                [placeholder]="
                                    'First name' | translate | asterisk
                                "
                            />
                            @if (showError('firstName')) {
                                <mat-error class="text-white"
                                    >{{ 'First name' | translate }}{{ ' ' }}
                                    {{ errorMessage('firstName') | translate }}
                                </mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field class="w-full" appearance="outline">
                            <input
                                formControlName="lastName"
                                matInput
                                required
                                data-qa="landing-page_register-last-name"
                                aria-label="Last name"
                                [placeholder]="
                                    'Last name' | translate | asterisk
                                "
                            />
                            @if (showError('lastName')) {
                                <mat-error class="text-white"
                                    >{{ 'Last name' | translate }}{{ ' ' }}
                                    {{ errorMessage('lastName') | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="pb-[5px]">
                        <mat-form-field class="w-full" appearance="outline">
                            <input
                                formControlName="email"
                                matInput
                                type="email"
                                data-qa="landing-page_register-email"
                                aria-label="Your email address"
                                [placeholder]="
                                    'Your email address' | translate | asterisk
                                "
                            />
                            @if (showError('email')) {
                                <mat-error class="text-white"
                                    >E-Mail
                                    {{ errorMessage('email') | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="pb-[5px]">
                        <mat-form-field class="w-full" appearance="outline">
                            <input
                                formControlName="company"
                                matInput
                                data-qa="landing-page_register-company"
                                aria-label="Company"
                                [placeholder]="'Company' | translate | asterisk"
                            />
                            @if (showError('company')) {
                                <mat-error class="text-white">
                                    {{ 'Company' | translate }}{{ ' ' }}
                                    {{ errorMessage('company') | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="pb-8 md:pb-10">
                        <mat-form-field class="w-full" appearance="outline">
                            <input
                                formControlName="phoneNumber"
                                matInput
                                data-qa="landing-page_register-phone-number"
                                aria-label="Phone number"
                                [placeholder]="'Phone number' | translate"
                            />
                            @if (showError('phoneNumber')) {
                                <mat-error class="text-white">
                                    {{ 'Phone number' | translate }}
                                    {{ ' ' }}
                                    {{
                                        errorMessage('phoneNumber') | translate
                                    }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div
                        [ngClass]="[
                            'flex',
                            'flex-col space-y-6',
                            'md:flex-row md:space-y-0 md:justify-between md:items-center',
                            'lg:flex-col lg:space-y-6 lg:items-start',
                            'xl:flex-row xl:space-y-0 xl:items-center',
                        ]"
                    >
                        <mat-checkbox
                            formControlName="dataPrivacyAccepted"
                            data-qa="landing-page_register-checkbox"
                            class="checkbox-secondary"
                        >
                            <span class="text-white privacy">
                                <translate>I've read the</translate>
                                <a
                                    [routerLink]="['/privacy']"
                                    target="_blank"
                                    rel="opener"
                                >
                                    <translate>privacy policy.</translate>
                                </a>
                                *
                            </span>
                        </mat-checkbox>

                        <app-button-group alignment="center">
                            <app-button
                                buttonType="flat-highlight"
                                data-qa="landing-page_register-confirm-button"
                                [disabled]="!formGroup.valid"
                                [status]="loading ? 'loading' : 'default'"
                                submit
                            >
                                <translate>Send</translate>
                            </app-button>
                        </app-button-group>
                    </div>
                </form>

                <div
                    [ngClass]="[
                        'w-full items-center',
                        'md:max-w-screen-sm',
                        'lg:max-w-full lg:flex-1 lg:min-w-0',
                    ]"
                >
                    <app-lottie
                        class="mx-auto lg:mx-0 w-full sm:w-[440px] xl:w-[520px] 2xl:w-[650px] pb-6 xl:pb-0"
                        path="/assets/animations/landing-page/register/data.json"
                        [aspectRatio]="[1, 1]"
                        cropTop="9.5%"
                        cropBottom="7.2%"
                    >
                    </app-lottie>
                </div>
            </div>
        </div>
    }
</section>
